import { createAction } from 'redux-actions'

import { types } from 'store/supportPanel/types'

export const hideChat = createAction(types.HIDE_CHAT)
export const hidePanel = createAction(types.HIDE_SUPPORT_PANEL)
export const showChat = createAction(types.SHOW_CHAT)
export const showPanel = createAction(types.SHOW_SUPPORT_PANEL)
